import {
  Stack,
  Avatar,
  TableRow,
  MenuItem,
  TableCell,
  Typography,
  IconButton,
  ListItemText,
  CircularProgress,
} from '@mui/material';

import Iconify from 'src/components/iconify';
import { RedeemTxType } from 'src/type/gold-withdraw';
import { fNumber } from 'src/utils/format-number';

import { fDate, fTime } from 'src/utils/format-time';
import { useBoolean } from 'src/hooks/use-boolean';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { convertGold } from 'src/utils/convert';
import { shortString } from 'src/utils/format-string';
import StockExportViewDialog from './stock-export-view-dialog';

type Props = {
  row: RedeemTxType;
  handleReload: () => void;
};

export default function StockExportTableRow({ row, handleReload }: Props) {
  const popover = usePopover();
  // const approve = useBoolean();
  // const reject = useBoolean();
  // const update = useBoolean();
  const view = useBoolean();

  const sending = useBoolean(false);

  const { user, userId, createdAt, amount, product, unitName, pricePerUnit } = row;

  const isOrnament = product?.isOrnament || false;

  // const handleSendPdf = async () => {
  //   try {
  //     sending.onTrue();
  //     await axios.get(endpoints.sendPdf.get(row.id));

  //     // await new Promise((resolve) => setTimeout(resolve, 5000));

  //     enqueueSnackbar('ส่งเอกสารถึงลูกค้าเรียบร้อย', {
  //       variant: 'success',
  //     });
  //   } catch (error) {
  //     enqueueSnackbar('ส่งเอกสารถึงลูกค้าไม่สำเร็จ', {
  //       variant: 'error',
  //     });
  //   } finally {
  //     popover.onClose();
  //     sending.onFalse();
  //   }
  // };

  return (
    <>
      <TableRow>
        <TableCell>
          <Stack direction="row">
            <Avatar alt="" sx={{ mr: 2 }}>
              {user?.firstName?.[0].toUpperCase()}
            </Avatar>

            <ListItemText
              disableTypography
              primary={
                <Typography variant="body2" noWrap>
                  {user?.firstName} {user?.lastName}
                </Typography>
              }
              secondary={
                <Typography variant="caption" color="text.secondary" noWrap>
                  #{shortString(userId)}
                </Typography>
              }
            />
          </Stack>
        </TableCell>

        <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar alt="" sx={{ mr: 2 }} src={product.imageUrl}>
            {product.name.charAt(0)}
          </Avatar>

          <ListItemText
            disableTypography
            primary={
              <Typography variant="body2" noWrap>
                {product.name}
              </Typography>
            }
          />
        </TableCell>

        <TableCell>
          <ListItemText
            primary={`${fNumber(amount, 3)} ${unitName || 'กรัม'}`}
            secondary={`≈ ${fNumber(convertGold(amount, unitName === 'กรัม' ? 'weightBaht' : 'weightGrams', unitName === 'กรัม' ? isOrnament : false))} ${unitName === 'กรัม' ? 'บาท' : 'กรัม'}`}
            primaryTypographyProps={{
              typography: 'subtitle1',
              noWrap: true,
            }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
              noWrap: true,
            }}
          />
        </TableCell>

        <TableCell>
          <ListItemText
            primary={`${fNumber(pricePerUnit || 0, 3)}`}
            secondary={`ต่อ${unitName}`}
            primaryTypographyProps={{
              typography: 'subtitle1',
              noWrap: true,
            }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
              noWrap: true,
            }}
          />
        </TableCell>

        <TableCell>
          <ListItemText
            primary={fDate(createdAt, 'DD MMMM BBBB')}
            secondary={fTime(createdAt)}
            primaryTypographyProps={{ typography: 'body2', noWrap: true }}
            secondaryTypographyProps={{
              mt: 0.5,
              component: 'span',
              typography: 'caption',
            }}
          />
        </TableCell>

        {/* <TableCell>
          {status === TransactionStatus.SUCCESS ? (
            <ListItemText
              primary={fDate(updatedAt, 'DD MMMM BBBB')}
              secondary={fTime(updatedAt)}
              primaryTypographyProps={{ typography: 'body2', noWrap: true }}
              secondaryTypographyProps={{
                mt: 0.5,
                component: 'span',
                typography: 'caption',
              }}
            />
          ) : (
            '-'
          )}
        </TableCell> */}

        {/* <TableCell>
          <Label
            variant="soft"
            color={
              (status === TransactionStatus.SUCCESS && 'success') ||
              (status === TransactionStatus.PENDING && 'warning') ||
              (status === TransactionStatus.REJECTED && 'error') ||
              (status === TransactionStatus.CANCEL && 'info') ||
              'default'
            }
          >
            {txStatusLabel(status)}
          </Label>
        </TableCell> */}

        <TableCell align="right" sx={{ px: 2 }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>

      <CustomPopover
        open={popover.open}
        onClose={sending.value ? undefined : popover.onClose}
        arrow="top-right"
        sx={{ width: 160 }}
      >
        {sending.value ? (
          <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} p={1}>
            <CircularProgress size={20} />
            <Typography variant="caption">กำลังส่งเอกสาร</Typography>
          </Stack>
        ) : (
          <>
            {/* {status === TransactionStatus.PENDING && (
              <>
                <MenuItem
                  onClick={() => {
                    popover.onClose();
                    approve.onTrue();
                  }}
                  sx={{ color: 'success.main' }}
                >
                  <Iconify icon="solar:check-square-bold" />
                  อนุมัติ
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    popover.onClose();
                    reject.onTrue();
                  }}
                  sx={{ color: 'error.main' }}
                >
                  <Iconify icon="solar:close-square-bold" />
                  ปฏิเสธ
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    popover.onClose();
                    update.onTrue();
                  }}
                  sx={{ color: 'warning.main' }}
                >
                  <Iconify icon="solar:calendar-mark-bold" />
                  เลื่อนวันรับ
                </MenuItem>
              </>
            )} */}

            <MenuItem
              onClick={() => {
                popover.onClose();
                view.onTrue();
              }}
            >
              <Iconify icon="solar:info-square-bold" />
              รายละเอียด
            </MenuItem>

            {/* {status === TransactionStatus.SUCCESS && (
              <MenuItem onClick={handleSendPdf}>
                <Iconify icon="solar:letter-bold" />
                ส่งเอกสาร
              </MenuItem>
            )} */}
          </>
        )}
      </CustomPopover>

      {/* {approve.value && (
        <StockExportApproveDialog
          open={approve.value}
          onClose={approve.onFalse}
          handleReload={handleReload}
          tx={row}
        />
      )} */}

      {/* {reject.value && (
        <StockExportRejectDialog
          open={reject.value}
          onClose={reject.onFalse}
          handleReload={handleReload}
          tx={row}
        />
      )} */}

      {view.value && <StockExportViewDialog open={view.value} onClose={view.onFalse} tx={row} />}
    </>
  );
}
